import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=9c638fda&"
import script from "./QuestionList.vue?vue&type=script&lang=ts&"
export * from "./QuestionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports